import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'

import { addHearts } from 'src/fancy/hearts'

const heartParams = target => {
  const rect = target.parentNode.querySelector('.fa-heart').getBoundingClientRect()
  return {
    count: 12,
    left: rect.left,
    top: rect.top,
    color: 'var(--bs-primary)',
  }
}

const Subscription = ({ i18n, frequencies, subscription, setSubscription, show_input_labels }) =>
  frequencies.length > 1 &&
  <fieldset className="mb-3 row-subs">
    <legend className={show_input_labels ? 'form-label fs-6' : 'visually-hidden'}>
      {i18n.t('subscription')}
    </legend>

    <div className="sub-options d-flex flex-wrap gap-2">
      {frequencies.map(option => {
        const id = `subOption_${option}`

        return (
          <div key={option} className="flex-grow-1 d-grid">
            <input
              type="radio"
              className="btn-check sub-option-btn"
              id={id}
              name="subscription"
              value={option}
              checked={option == subscription}
              onChange={e => {
                setSubscription(option)
                // In case of error, don't crash entire form
                if (option == 'monthly') {
                  const target = e.target
                  setTimeout(() => addHearts(heartParams(target)), 1)
                }
              }}
            />
            <label
              className="btn btn-light btn-check-special sub-option-label"
              htmlFor={id}
            >
              {
                option == 'monthly' &&
                <FontAwesomeIcon icon={faHeart} className="text-primary me-2" />
              }
              <span>{i18n.t(`subscription_labels.${option}.option`)}</span>
            </label>
          </div>
        )
      })}
    </div>
  </fieldset>

export default Subscription
